import { render, staticRenderFns } from "./descriptions-item.vue?vue&type=template&id=71bde039&scoped=true"
import script from "./descriptions-item.vue?vue&type=script&lang=js"
export * from "./descriptions-item.vue?vue&type=script&lang=js"
import style0 from "./descriptions-item.vue?vue&type=style&index=0&id=71bde039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bde039",
  null
  
)

export default component.exports